import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { I18N_NAMESPACES } from "../../../helpers/constants";
import { GetWine_wine as WineType } from "../../../types/__generated__/GetWine";

import { Content, SeeMore, Text, TextWrapper, SectionTitle } from "./style";

interface WineStoryProps {
  wine: WineType | null | undefined;
}

const WineStory = ({ wine }: WineStoryProps) => {
  const { t } = useTranslation([I18N_NAMESPACES.WINE_PAGES, I18N_NAMESPACES.COMMON]);
  const sommelierNotes = wine?.sommelierNotes ?? "";
  const fullDescription = wine?.fullDescription;

  // Remove sommelierNotes from fullDescription to avoid duplicate paragraphs in the wine story.
  const fullDescriptionWithoutSommelierNotes = fullDescription?.replace(sommelierNotes, "");

  const [isReadMoreShown, setIsReadMoreShown] = useState<boolean>(true);

  const buttonLocaleKey = isReadMoreShown ? "readMore" : "readLess";

  return (
    <>
      <SectionTitle>{t("winePages:details")}</SectionTitle>
      <Content>
        <TextWrapper isOpen={!isReadMoreShown}>
          <Text>
            {sommelierNotes}
            {/* Use line break to keep webkit-line-clamp works */}
            <br />
            <br />
            {/* Use line break to keep webkit-line-clamp works */}
            {fullDescriptionWithoutSommelierNotes}
          </Text>
        </TextWrapper>
        <SeeMore onClick={() => setIsReadMoreShown(!isReadMoreShown)}>
          {t(`common:${buttonLocaleKey}`)}
        </SeeMore>
      </Content>
    </>
  );
};

export default WineStory;
